import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { useSelectContext } from '../../../hooks/useSelectContext.js';

var _excluded = ["onChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useSelectBottomSheet = function useSelectBottomSheet(props) {
  var onChange = props.onChange,
    rest = _objectWithoutProperties(props, _excluded);
  var _useSelectContext = useSelectContext(),
    triggerRef = _useSelectContext.triggerRef,
    state = _useSelectContext.state;
  var onVisibleChange = function onVisibleChange(visible) {
    onChange === null || onChange === void 0 || onChange(visible);
    state === null || state === void 0 || state.close();
  };
  return {
    triggerRef: triggerRef,
    state: state,
    bottomSheetProps: _objectSpread(_objectSpread({
      p: '8'
    }, rest), {}, {
      visible: state === null || state === void 0 ? void 0 : state.isOpen,
      onChange: onVisibleChange
    })
  };
};

export { useSelectBottomSheet };
//# sourceMappingURL=useSelectBottomSheet.js.map
